import React from 'react'
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({children}) => {
  
    const token = sessionStorage.getItem('authToken');
    if(!token){
        return <Navigate to="/" />;
    }
    return children;
}

export default ProtectedRoute;

 